"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7813],{

/***/ 78150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getLocationsAutocompleteSelfDatabase; },
/* harmony export */   "Fx": function() { return /* binding */ getSearchKeywords; },
/* harmony export */   "U_": function() { return /* binding */ getLocationDetails; },
/* harmony export */   "iN": function() { return /* binding */ getLocationsAutocomplete; },
/* harmony export */   "z1": function() { return /* binding */ getSearchAutocomplete; }
/* harmony export */ });
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57947);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66548);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var basePath = "https://www.doctify.com/webapi";
var internalApiUrl = "https://www.doctify.com";
var getLocationsAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, language, lat, lon, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, language = param.language, lat = param.lat, lon = param.lon;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_2__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        language: language,
                        lat: lat,
                        lon: lon
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete-locations?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationsAutocompleteSelfDatabase = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang, keywordId, search, type, searchParams, queryParams, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang, keywordId = param.keywordId, search = param.search, type = param.type;
                    searchParams = new URLSearchParams();
                    if (keywordId && keywordId !== 1) {
                        searchParams.append("keywordId", keywordId.toString());
                    }
                    if (search === null || search === void 0 ? void 0 : search.length) {
                        searchParams.append("search", search);
                    }
                    if (type) {
                        searchParams.append("type", type);
                    }
                    queryParams = searchParams.toString();
                    url = "".concat(internalApiUrl, "/").concat(lang, "/api/search/locations");
                    if (locationId) {
                        url += "/".concat(locationId);
                    }
                    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.length) {
                        url += "?".concat(queryParams);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }).then(function(r) {
                        return r.data;
                    }));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocompleteSelfDatabase(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationDetails = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang;
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/location-details/").concat(locationId)).then(function(r) {
                        return r.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationDetails(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, type, specialties, searchType, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, type = param.type, specialties = param.specialties, searchType = param.searchType;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_2__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        type: type,
                        specialties: specialties,
                        searchType: searchType
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchKeywords = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keywordId, keywordType, locationId, locale, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keywordId = param.keywordId, keywordType = param.keywordType, locationId = param.locationId, locale = param.locale;
                    url = "".concat(internalApiUrl, "/").concat(locale, "/api/keywords?");
                    if (keywordType) {
                        url += "keyword_type=".concat(keywordType, "&");
                    }
                    if (locationId) {
                        url += "locationId=".concat(locationId);
                    }
                    if (keywordId && keywordId !== 1) {
                        url += "&keywordId=".concat(keywordId);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchKeywords(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 87987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Avatar; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js + 21 modules
var styled_esm = __webpack_require__(84857);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
;// CONCATENATED MODULE: ./components/Avatar/styles.ts

var AvatarContainer = (0,styled_esm/* default */.Z)(Box_esm/* default */.Z)({
    position: "relative",
    overflow: "hidden",
    borderRadius: "4px",
    "span, img": {
        width: "100% !important",
        height: "100% !important",
        objectFit: "cover",
        zIndex: 1
    }
});
var AvatarChildrenContainer = (0,styled_esm/* default */.Z)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        color: theme.palette.common.white,
        fontSize: "21px"
    };
});

// EXTERNAL MODULE: ./utils/imageLoaders.ts
var imageLoaders = __webpack_require__(38776);
// EXTERNAL MODULE: ../../../node_modules/next/head.js
var head = __webpack_require__(46582);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/Avatar/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var AVATAR_LOADING_SIZE = 256;
var Avatar = function(_param) {
    var avatarSrc = _param.src, alt = _param.alt, children = _param.children, width = _param.width, height = _param.height, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, _lazy = _param.lazy, lazy = _lazy === void 0 ? false : _lazy, withDoctifyCDNLoader = _param.withDoctifyCDNLoader, props = _objectWithoutProperties(_param, [
        "src",
        "alt",
        "children",
        "width",
        "height",
        "preload",
        "lazy",
        "withDoctifyCDNLoader"
    ]);
    var ref = (0,react.useState)(!avatarSrc), isFallback = ref[0], setIsFallback = ref[1];
    var priority = (0,react.useMemo)(function() {
        return lazy ? false : preload;
    }, [
        lazy,
        preload
    ]);
    var loading = (0,react.useMemo)(function() {
        return lazy ? "lazy" : "eager";
    }, [
        lazy
    ]);
    var handleLoadError = (0,react.useCallback)(function() {
        return setIsFallback(true);
    }, []);
    var imageHref = (0,react.useMemo)(function() {
        if (!avatarSrc) {
            return "";
        }
        var loaderProps = {
            src: avatarSrc,
            width: AVATAR_LOADING_SIZE
        };
        return withDoctifyCDNLoader ? (0,imageLoaders/* doctifyCDNLoader */.Ux)(loaderProps) : (0,imageLoaders/* defaultLoader */.xy)(loaderProps);
    }, [
        avatarSrc,
        withDoctifyCDNLoader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            priority && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: imageHref
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, _objectSpread({
                className: "profile-avatar-container",
                bgcolor: isFallback ? "grey.400" : "common.white",
                width: width,
                height: height
            }, props, {
                children: [
                    imageHref && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: alt,
                        src: imageHref,
                        width: width,
                        height: height,
                        onError: handleLoadError,
                        onAbort: handleLoadError,
                        loading: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarChildrenContainer, {
                        container: true,
                        alignItems: "center",
                        justifyContent: "center",
                        children: isFallback && children
                    })
                ]
            }))
        ]
    });
};
var AvatarComponent = /*#__PURE__*/ (0,react.memo)(Avatar);
/* harmony default export */ var components_Avatar = (AvatarComponent);


/***/ }),

/***/ 61036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);


var errorDescriptionMap = {
    "404": "This page could not be found.",
    "500": "Internal server error.",
    default: "This page could not be found."
};
// Mimic default Next error page
var Error = function(param) {
    var statusCode = param.statusCode, errorText = param.errorText;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.style.backgroundColor = "#000";
    }, []);
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
            height: "100vh",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        borderRight: "1px solid rgba(255, 255, 255, .3)"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        style: {
                            display: "inline-block",
                            margin: "0",
                            padding: "10px 23px 10px 0",
                            fontSize: "24px",
                            fontWeight: "500",
                            verticalAlign: "top"
                        },
                        children: statusCode
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "inherit",
                        padding: "0 0 6px 0",
                        margin: "0"
                    },
                    children: (ref = errorText !== null && errorText !== void 0 ? errorText : errorDescriptionMap[statusCode]) !== null && ref !== void 0 ? ref : errorDescriptionMap["default"]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Error);


/***/ }),

/***/ 9871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93716);
/* harmony import */ var _utils_addRtlProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47703);


var ArrowRight = (0,_utils_addRtlProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 47010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var FeeAgreedBadge = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        width: "130",
        height: "39",
        viewBox: "0 0 130 39"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "106",
            height: "29",
            viewBox: "0 0 106 29",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0 4.68079C0 3.57622 0.895431 2.68079 2 2.68079H98.4968C100.145 2.68079 101.086 4.56352 100.096 5.88182L93.678 14.4275C93.1437 15.139 93.1437 16.1181 93.678 16.8296L100.096 25.3753C101.086 26.6936 100.145 28.5763 98.4968 28.5763H2C0.895429 28.5763 0 27.6809 0 26.5763V4.68079Z",
                    fill: "#2258B1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2 2.3263C2 1.22173 2.89543 0.326294 4 0.326294H102.008C103.655 0.326294 104.596 2.20487 103.61 3.52374L97.0289 12.3276C96.4981 13.0377 96.4981 14.0124 97.0289 14.7225L103.61 23.5264C104.596 24.8453 103.655 26.7238 102.008 26.7238H4C2.89543 26.7238 2 25.8284 2 24.7238V2.3263Z",
                    fill: "#FFE585"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.5857 9.28536V10.3084H12.3407V12.5634H14.8707V13.5864H12.3407V16.9304H11.0867V9.28536H15.5857ZM22.3029 13.7514C22.3029 13.9787 22.2882 14.184 22.2589 14.3674H17.6279C17.6645 14.8514 17.8442 15.24 18.1669 15.5334C18.4895 15.8267 18.8855 15.9734 19.3549 15.9734C20.0295 15.9734 20.5062 15.691 20.7849 15.1264H22.1379C21.9545 15.6837 21.6209 16.142 21.1369 16.5014C20.6602 16.8534 20.0662 17.0294 19.3549 17.0294C18.7755 17.0294 18.2549 16.901 17.7929 16.6444C17.3382 16.3804 16.9789 16.0137 16.7149 15.5444C16.4582 15.0677 16.3299 14.5177 16.3299 13.8944C16.3299 13.271 16.4545 12.7247 16.7039 12.2554C16.9605 11.7787 17.3162 11.412 17.7709 11.1554C18.2329 10.8987 18.7609 10.7704 19.3549 10.7704C19.9269 10.7704 20.4365 10.895 20.8839 11.1444C21.3312 11.3937 21.6795 11.7457 21.9289 12.2004C22.1782 12.6477 22.3029 13.1647 22.3029 13.7514ZM20.9939 13.3554C20.9865 12.8934 20.8215 12.523 20.4989 12.2444C20.1762 11.9657 19.7765 11.8264 19.2999 11.8264C18.8672 11.8264 18.4969 11.9657 18.1889 12.2444C17.8809 12.5157 17.6975 12.886 17.6389 13.3554H20.9939ZM29.0919 13.7514C29.0919 13.9787 29.0772 14.184 29.0479 14.3674H24.4169C24.4536 14.8514 24.6332 15.24 24.9559 15.5334C25.2786 15.8267 25.6746 15.9734 26.1439 15.9734C26.8186 15.9734 27.2952 15.691 27.5739 15.1264H28.9269C28.7436 15.6837 28.4099 16.142 27.9259 16.5014C27.4492 16.8534 26.8552 17.0294 26.1439 17.0294C25.5646 17.0294 25.0439 16.901 24.5819 16.6444C24.1272 16.3804 23.7679 16.0137 23.5039 15.5444C23.2472 15.0677 23.1189 14.5177 23.1189 13.8944C23.1189 13.271 23.2436 12.7247 23.4929 12.2554C23.7496 11.7787 24.1052 11.412 24.5599 11.1554C25.0219 10.8987 25.5499 10.7704 26.1439 10.7704C26.7159 10.7704 27.2256 10.895 27.6729 11.1444C28.1202 11.3937 28.4686 11.7457 28.7179 12.2004C28.9672 12.6477 29.0919 13.1647 29.0919 13.7514ZM27.7829 13.3554C27.7756 12.8934 27.6106 12.523 27.2879 12.2444C26.9652 11.9657 26.5656 11.8264 26.0889 11.8264C25.6562 11.8264 25.2859 11.9657 24.9779 12.2444C24.6699 12.5157 24.4866 12.886 24.4279 13.3554H27.7829ZM37.7924 15.3684H34.5914L34.0414 16.9304H32.7324L35.4714 9.27436H36.9234L39.6624 16.9304H38.3424L37.7924 15.3684ZM37.4404 14.3454L36.1974 10.7924L34.9434 14.3454H37.4404ZM43.2953 10.7704C43.7647 10.7704 44.179 10.8657 44.5383 11.0564C44.905 11.2397 45.191 11.4707 45.3963 11.7494V10.8694H46.6613V17.0294C46.6613 17.5867 46.544 18.0817 46.3093 18.5144C46.0747 18.9544 45.7337 19.299 45.2863 19.5484C44.8463 19.7977 44.3183 19.9224 43.7023 19.9224C42.881 19.9224 42.199 19.728 41.6563 19.3394C41.1137 18.958 40.8057 18.4374 40.7323 17.7774H41.9753C42.0707 18.0927 42.2723 18.3457 42.5803 18.5364C42.8957 18.7344 43.2697 18.8334 43.7023 18.8334C44.2083 18.8334 44.6153 18.6794 44.9233 18.3714C45.2387 18.0634 45.3963 17.616 45.3963 17.0294V16.0174C45.1837 16.3034 44.894 16.5454 44.5273 16.7434C44.168 16.934 43.7573 17.0294 43.2953 17.0294C42.7673 17.0294 42.2833 16.8974 41.8433 16.6334C41.4107 16.362 41.066 15.988 40.8093 15.5114C40.56 15.0274 40.4353 14.481 40.4353 13.8724C40.4353 13.2637 40.56 12.7247 40.8093 12.2554C41.066 11.786 41.4107 11.423 41.8433 11.1664C42.2833 10.9024 42.7673 10.7704 43.2953 10.7704ZM45.3963 13.8944C45.3963 13.4764 45.3083 13.1134 45.1323 12.8054C44.9637 12.4974 44.74 12.2627 44.4613 12.1014C44.1827 11.94 43.882 11.8594 43.5593 11.8594C43.2367 11.8594 42.936 11.94 42.6573 12.1014C42.3787 12.2554 42.1513 12.4864 41.9753 12.7944C41.8067 13.095 41.7223 13.4544 41.7223 13.8724C41.7223 14.2904 41.8067 14.657 41.9753 14.9724C42.1513 15.2877 42.3787 15.5297 42.6573 15.6984C42.9433 15.8597 43.244 15.9404 43.5593 15.9404C43.882 15.9404 44.1827 15.8597 44.4613 15.6984C44.74 15.537 44.9637 15.3024 45.1323 14.9944C45.3083 14.679 45.3963 14.3124 45.3963 13.8944ZM49.5624 11.7494C49.7457 11.4414 49.9877 11.203 50.2884 11.0344C50.5964 10.8584 50.9594 10.7704 51.3774 10.7704V12.0684H51.0584C50.5671 12.0684 50.1931 12.193 49.9364 12.4424C49.6871 12.6917 49.5624 13.1244 49.5624 13.7404V16.9304H48.3084V10.8694H49.5624V11.7494ZM58.0851 13.7514C58.0851 13.9787 58.0704 14.184 58.0411 14.3674H53.4101C53.4467 14.8514 53.6264 15.24 53.9491 15.5334C54.2717 15.8267 54.6677 15.9734 55.1371 15.9734C55.8117 15.9734 56.2884 15.691 56.5671 15.1264H57.9201C57.7367 15.6837 57.4031 16.142 56.9191 16.5014C56.4424 16.8534 55.8484 17.0294 55.1371 17.0294C54.5577 17.0294 54.0371 16.901 53.5751 16.6444C53.1204 16.3804 52.7611 16.0137 52.4971 15.5444C52.2404 15.0677 52.1121 14.5177 52.1121 13.8944C52.1121 13.271 52.2367 12.7247 52.4861 12.2554C52.7427 11.7787 53.0984 11.412 53.5531 11.1554C54.0151 10.8987 54.5431 10.7704 55.1371 10.7704C55.7091 10.7704 56.2187 10.895 56.6661 11.1444C57.1134 11.3937 57.4617 11.7457 57.7111 12.2004C57.9604 12.6477 58.0851 13.1647 58.0851 13.7514ZM56.7761 13.3554C56.7687 12.8934 56.6037 12.523 56.2811 12.2444C55.9584 11.9657 55.5587 11.8264 55.0821 11.8264C54.6494 11.8264 54.2791 11.9657 53.9711 12.2444C53.6631 12.5157 53.4797 12.886 53.4211 13.3554H56.7761ZM64.8741 13.7514C64.8741 13.9787 64.8595 14.184 64.8301 14.3674H60.1991C60.2358 14.8514 60.4155 15.24 60.7381 15.5334C61.0608 15.8267 61.4568 15.9734 61.9261 15.9734C62.6008 15.9734 63.0775 15.691 63.3561 15.1264H64.7091C64.5258 15.6837 64.1921 16.142 63.7081 16.5014C63.2315 16.8534 62.6375 17.0294 61.9261 17.0294C61.3468 17.0294 60.8261 16.901 60.3641 16.6444C59.9095 16.3804 59.5501 16.0137 59.2861 15.5444C59.0295 15.0677 58.9011 14.5177 58.9011 13.8944C58.9011 13.271 59.0258 12.7247 59.2751 12.2554C59.5318 11.7787 59.8875 11.412 60.3421 11.1554C60.8041 10.8987 61.3321 10.7704 61.9261 10.7704C62.4981 10.7704 63.0078 10.895 63.4551 11.1444C63.9025 11.3937 64.2508 11.7457 64.5001 12.2004C64.7495 12.6477 64.8741 13.1647 64.8741 13.7514ZM63.5651 13.3554C63.5578 12.8934 63.3928 12.523 63.0701 12.2444C62.7475 11.9657 62.3478 11.8264 61.8711 11.8264C61.4385 11.8264 61.0681 11.9657 60.7601 12.2444C60.4521 12.5157 60.2688 12.886 60.2101 13.3554H63.5651ZM65.6902 13.8724C65.6902 13.2637 65.8149 12.7247 66.0642 12.2554C66.3209 11.786 66.6655 11.423 67.0982 11.1664C67.5382 10.9024 68.0259 10.7704 68.5612 10.7704C68.9572 10.7704 69.3459 10.8584 69.7272 11.0344C70.1159 11.203 70.4239 11.4304 70.6512 11.7164V8.79036H71.9162V16.9304H70.6512V16.0174C70.4459 16.3107 70.1599 16.5527 69.7932 16.7434C69.4339 16.934 69.0195 17.0294 68.5502 17.0294C68.0222 17.0294 67.5382 16.8974 67.0982 16.6334C66.6655 16.362 66.3209 15.988 66.0642 15.5114C65.8149 15.0274 65.6902 14.481 65.6902 13.8724ZM70.6512 13.8944C70.6512 13.4764 70.5632 13.1134 70.3872 12.8054C70.2185 12.4974 69.9949 12.2627 69.7162 12.1014C69.4375 11.94 69.1369 11.8594 68.8142 11.8594C68.4915 11.8594 68.1909 11.94 67.9122 12.1014C67.6335 12.2554 67.4062 12.4864 67.2302 12.7944C67.0615 13.095 66.9772 13.4544 66.9772 13.8724C66.9772 14.2904 67.0615 14.657 67.2302 14.9724C67.4062 15.2877 67.6335 15.5297 67.9122 15.6984C68.1982 15.8597 68.4989 15.9404 68.8142 15.9404C69.1369 15.9404 69.4375 15.8597 69.7162 15.6984C69.9949 15.537 70.2185 15.3024 70.3872 14.9944C70.5632 14.679 70.6512 14.3124 70.6512 13.8944Z",
                    fill: "#142F76"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "84.1246",
                    cy: "10.9661",
                    r: "3.95433",
                    stroke: "#142F76",
                    "stroke-width": "1.2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M81.6406 14.1121V19.0484C81.6406 19.4845 82.1599 19.7116 82.4801 19.4155L83.7851 18.2088C83.9767 18.0316 84.2724 18.0316 84.464 18.2088L85.769 19.4155C86.0892 19.7116 86.6085 19.4845 86.6085 19.0484V14.1121",
                    stroke: "#142F76",
                    "stroke-width": "1.2"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FeeAgreedBadge);


/***/ }),

/***/ 25056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var FeeAgreedBadge = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        width: "130",
        height: "39",
        viewBox: "0 0 130 39"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "107",
            height: "29",
            viewBox: "0 0 107 29",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.601562 4.35449C0.601562 3.24993 1.49699 2.35449 2.60156 2.35449H99.0983C100.747 2.35449 101.688 4.23722 100.698 5.55553L94.2796 14.1012C93.7452 14.8128 93.7452 15.7918 94.2796 16.5033L100.698 25.049C101.688 26.3673 100.747 28.25 99.0983 28.25H2.60156C1.49699 28.25 0.601562 27.3546 0.601562 26.25V4.35449Z",
                    fill: "#2258B1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.60156 2C2.60156 0.895433 3.49699 0 4.60156 0H102.61C104.256 0 105.197 1.87858 104.211 3.19745L97.6304 12.0013C97.0996 12.7114 97.0996 13.6861 97.6304 14.3962L104.211 23.2001C105.197 24.519 104.256 26.3975 102.61 26.3975H4.60156C3.49699 26.3975 2.60156 25.5021 2.60156 24.3975V2Z",
                    fill: "#FFE585"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M16.1873 8.959V9.982H12.9423V12.237H15.4723V13.26H12.9423V16.604H11.6883V8.959H16.1873ZM22.9044 13.425C22.9044 13.6523 22.8897 13.8577 22.8604 14.041H18.2294C18.2661 14.525 18.4457 14.9137 18.7684 15.207C19.0911 15.5003 19.4871 15.647 19.9564 15.647C20.6311 15.647 21.1077 15.3647 21.3864 14.8H22.7394C22.5561 15.3573 22.2224 15.8157 21.7384 16.175C21.2617 16.527 20.6677 16.703 19.9564 16.703C19.3771 16.703 18.8564 16.5747 18.3944 16.318C17.9397 16.054 17.5804 15.6873 17.3164 15.218C17.0597 14.7413 16.9314 14.1913 16.9314 13.568C16.9314 12.9447 17.0561 12.3983 17.3054 11.929C17.5621 11.4523 17.9177 11.0857 18.3724 10.829C18.8344 10.5723 19.3624 10.444 19.9564 10.444C20.5284 10.444 21.0381 10.5687 21.4854 10.818C21.9327 11.0673 22.2811 11.4193 22.5304 11.874C22.7797 12.3213 22.9044 12.8383 22.9044 13.425ZM21.5954 13.029C21.5881 12.567 21.4231 12.1967 21.1004 11.918C20.7777 11.6393 20.3781 11.5 19.9014 11.5C19.4687 11.5 19.0984 11.6393 18.7904 11.918C18.4824 12.1893 18.2991 12.5597 18.2404 13.029H21.5954ZM29.6935 13.425C29.6935 13.6523 29.6788 13.8577 29.6495 14.041H25.0185C25.0551 14.525 25.2348 14.9137 25.5575 15.207C25.8801 15.5003 26.2761 15.647 26.7455 15.647C27.4201 15.647 27.8968 15.3647 28.1755 14.8H29.5285C29.3451 15.3573 29.0115 15.8157 28.5275 16.175C28.0508 16.527 27.4568 16.703 26.7455 16.703C26.1661 16.703 25.6455 16.5747 25.1835 16.318C24.7288 16.054 24.3695 15.6873 24.1055 15.218C23.8488 14.7413 23.7205 14.1913 23.7205 13.568C23.7205 12.9447 23.8451 12.3983 24.0945 11.929C24.3511 11.4523 24.7068 11.0857 25.1615 10.829C25.6235 10.5723 26.1515 10.444 26.7455 10.444C27.3175 10.444 27.8271 10.5687 28.2745 10.818C28.7218 11.0673 29.0701 11.4193 29.3195 11.874C29.5688 12.3213 29.6935 12.8383 29.6935 13.425ZM28.3845 13.029C28.3771 12.567 28.2121 12.1967 27.8895 11.918C27.5668 11.6393 27.1671 11.5 26.6905 11.5C26.2578 11.5 25.8875 11.6393 25.5795 11.918C25.2715 12.1893 25.0881 12.5597 25.0295 13.029H28.3845ZM38.394 15.042H35.193L34.643 16.604H33.334L36.073 8.948H37.525L40.264 16.604H38.944L38.394 15.042ZM38.042 14.019L36.799 10.466L35.545 14.019H38.042ZM43.8969 10.444C44.3662 10.444 44.7805 10.5393 45.1399 10.73C45.5065 10.9133 45.7925 11.1443 45.9979 11.423V10.543H47.2629V16.703C47.2629 17.2603 47.1455 17.7553 46.9109 18.188C46.6762 18.628 46.3352 18.9727 45.8879 19.222C45.4479 19.4713 44.9199 19.596 44.3039 19.596C43.4825 19.596 42.8005 19.4017 42.2579 19.013C41.7152 18.6317 41.4072 18.111 41.3339 17.451H42.5769C42.6722 17.7663 42.8739 18.0193 43.1819 18.21C43.4972 18.408 43.8712 18.507 44.3039 18.507C44.8099 18.507 45.2169 18.353 45.5249 18.045C45.8402 17.737 45.9979 17.2897 45.9979 16.703V15.691C45.7852 15.977 45.4955 16.219 45.1289 16.417C44.7695 16.6077 44.3589 16.703 43.8969 16.703C43.3689 16.703 42.8849 16.571 42.4449 16.307C42.0122 16.0357 41.6675 15.6617 41.4109 15.185C41.1615 14.701 41.0369 14.1547 41.0369 13.546C41.0369 12.9373 41.1615 12.3983 41.4109 11.929C41.6675 11.4597 42.0122 11.0967 42.4449 10.84C42.8849 10.576 43.3689 10.444 43.8969 10.444ZM45.9979 13.568C45.9979 13.15 45.9099 12.787 45.7339 12.479C45.5652 12.171 45.3415 11.9363 45.0629 11.775C44.7842 11.6137 44.4835 11.533 44.1609 11.533C43.8382 11.533 43.5375 11.6137 43.2589 11.775C42.9802 11.929 42.7529 12.16 42.5769 12.468C42.4082 12.7687 42.3239 13.128 42.3239 13.546C42.3239 13.964 42.4082 14.3307 42.5769 14.646C42.7529 14.9613 42.9802 15.2033 43.2589 15.372C43.5449 15.5333 43.8455 15.614 44.1609 15.614C44.4835 15.614 44.7842 15.5333 45.0629 15.372C45.3415 15.2107 45.5652 14.976 45.7339 14.668C45.9099 14.3527 45.9979 13.986 45.9979 13.568ZM50.164 11.423C50.3473 11.115 50.5893 10.8767 50.89 10.708C51.198 10.532 51.561 10.444 51.979 10.444V11.742H51.66C51.1686 11.742 50.7946 11.8667 50.538 12.116C50.2886 12.3653 50.164 12.798 50.164 13.414V16.604H48.91V10.543H50.164V11.423ZM58.6866 13.425C58.6866 13.6523 58.672 13.8577 58.6426 14.041H54.0116C54.0483 14.525 54.228 14.9137 54.5506 15.207C54.8733 15.5003 55.2693 15.647 55.7386 15.647C56.4133 15.647 56.89 15.3647 57.1686 14.8H58.5216C58.3383 15.3573 58.0046 15.8157 57.5206 16.175C57.044 16.527 56.45 16.703 55.7386 16.703C55.1593 16.703 54.6386 16.5747 54.1766 16.318C53.722 16.054 53.3626 15.6873 53.0986 15.218C52.842 14.7413 52.7136 14.1913 52.7136 13.568C52.7136 12.9447 52.8383 12.3983 53.0876 11.929C53.3443 11.4523 53.7 11.0857 54.1546 10.829C54.6166 10.5723 55.1446 10.444 55.7386 10.444C56.3106 10.444 56.8203 10.5687 57.2676 10.818C57.715 11.0673 58.0633 11.4193 58.3126 11.874C58.562 12.3213 58.6866 12.8383 58.6866 13.425ZM57.3776 13.029C57.3703 12.567 57.2053 12.1967 56.8826 11.918C56.56 11.6393 56.1603 11.5 55.6836 11.5C55.251 11.5 54.8806 11.6393 54.5726 11.918C54.2646 12.1893 54.0813 12.5597 54.0226 13.029H57.3776ZM65.4757 13.425C65.4757 13.6523 65.461 13.8577 65.4317 14.041H60.8007C60.8374 14.525 61.017 14.9137 61.3397 15.207C61.6624 15.5003 62.0584 15.647 62.5277 15.647C63.2024 15.647 63.679 15.3647 63.9577 14.8H65.3107C65.1274 15.3573 64.7937 15.8157 64.3097 16.175C63.833 16.527 63.239 16.703 62.5277 16.703C61.9484 16.703 61.4277 16.5747 60.9657 16.318C60.511 16.054 60.1517 15.6873 59.8877 15.218C59.631 14.7413 59.5027 14.1913 59.5027 13.568C59.5027 12.9447 59.6274 12.3983 59.8767 11.929C60.1334 11.4523 60.489 11.0857 60.9437 10.829C61.4057 10.5723 61.9337 10.444 62.5277 10.444C63.0997 10.444 63.6094 10.5687 64.0567 10.818C64.504 11.0673 64.8524 11.4193 65.1017 11.874C65.351 12.3213 65.4757 12.8383 65.4757 13.425ZM64.1667 13.029C64.1594 12.567 63.9944 12.1967 63.6717 11.918C63.349 11.6393 62.9494 11.5 62.4727 11.5C62.04 11.5 61.6697 11.6393 61.3617 11.918C61.0537 12.1893 60.8704 12.5597 60.8117 13.029H64.1667ZM66.2918 13.546C66.2918 12.9373 66.4164 12.3983 66.6658 11.929C66.9224 11.4597 67.2671 11.0967 67.6998 10.84C68.1398 10.576 68.6274 10.444 69.1628 10.444C69.5588 10.444 69.9474 10.532 70.3288 10.708C70.7174 10.8767 71.0254 11.104 71.2528 11.39V8.464H72.5178V16.604H71.2528V15.691C71.0474 15.9843 70.7614 16.2263 70.3948 16.417C70.0354 16.6077 69.6211 16.703 69.1518 16.703C68.6238 16.703 68.1398 16.571 67.6998 16.307C67.2671 16.0357 66.9224 15.6617 66.6658 15.185C66.4164 14.701 66.2918 14.1547 66.2918 13.546ZM71.2528 13.568C71.2528 13.15 71.1648 12.787 70.9888 12.479C70.8201 12.171 70.5964 11.9363 70.3178 11.775C70.0391 11.6137 69.7384 11.533 69.4158 11.533C69.0931 11.533 68.7924 11.6137 68.5138 11.775C68.2351 11.929 68.0078 12.16 67.8318 12.468C67.6631 12.7687 67.5788 13.128 67.5788 13.546C67.5788 13.964 67.6631 14.3307 67.8318 14.646C68.0078 14.9613 68.2351 15.2033 68.5138 15.372C68.7998 15.5333 69.1004 15.614 69.4158 15.614C69.7384 15.614 70.0391 15.5333 70.3178 15.372C70.5964 15.2107 70.8201 14.976 70.9888 14.668C71.1648 14.3527 71.2528 13.986 71.2528 13.568Z",
                    fill: "#142F76"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "84.7301",
                    cy: "10.6398",
                    r: "3.95433",
                    stroke: "#142F76",
                    "stroke-width": "1.2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M82.2461 13.7858V18.7221C82.2461 19.1581 82.7654 19.3852 83.0856 19.0892L84.3906 17.8825C84.5822 17.7053 84.8779 17.7053 85.0695 17.8825L86.3745 19.0892C86.6947 19.3852 87.2139 19.1581 87.2139 18.7221V13.7858",
                    stroke: "#142F76",
                    "stroke-width": "1.2"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FeeAgreedBadge);


/***/ }),

/***/ 95346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46582);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PageMeta = function(meta) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }),
            meta.isProfile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "profile"
                    }),
                    !!meta.profileFirstName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:first_name",
                        content: meta.profileFirstName
                    }),
                    !!meta.profileLastName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:last_name",
                        content: meta.profileLastName
                    }),
                    !!meta.profileSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:username",
                        content: meta.profileSlug
                    }),
                    !!meta.profileGender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:gender",
                        content: meta.profileGender
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Doctify"
            }),
            !!meta.preloadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: meta.preloadImage
            }),
            !!meta.canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: meta.canonicalUrl,
                        hrefLang: meta.language
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: meta.canonicalUrl
                    })
                ]
            }),
            (meta === null || meta === void 0 ? void 0 : meta.noindex) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }) : null,
            !!meta.hrefLangs && meta.hrefLangs.map(function(hrefLang) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, hrefLang), "meta-hreflang-".concat(hrefLang.hreflang));
            }),
            meta.children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 95916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Variants; },
  "Z": function() { return /* binding */ components_Avatar; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(21684);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js + 21 modules
var styled_esm = __webpack_require__(84857);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 3 modules
var Button_esm = __webpack_require__(93247);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/PlayCircle/index.esm.js
var index_esm = __webpack_require__(58568);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(58877);
// EXTERNAL MODULE: ./utils/getImageWithWWW.ts
var getImageWithWWW = __webpack_require__(85666);
// EXTERNAL MODULE: ./components/profiles/Intro/variants/default/index.tsx + 1 modules
var variants_default = __webpack_require__(6875);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
;// CONCATENATED MODULE: ./components/profiles/Intro/components/Avatar/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var AvatarContainerVariant1 = (0,styled_esm/* default */.Z)(styles/* StyledAvatarContainer */.yJ)({});
var AvatarContainerVariant2 = (0,styled_esm/* default */.Z)(styles/* StyledAvatarContainer */.yJ)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderRadius: "8px",
        width: "217px",
        height: "217px"
    }, theme.breakpoints.down("sm"), {
        width: "97px",
        height: "97px"
    });
});
var AvatarVariant1 = (0,styled_esm/* default */.Z)(styles/* StyledAvatar */.bw)({});
var AvatarVariant2 = (0,styled_esm/* default */.Z)(styles/* StyledAvatar */.bw)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderRadius: "8px",
        border: "solid thin #BFCDF6",
        width: "217px",
        height: "217px",
        backgroundColor: "#FFFFFF !important"
    }, theme.breakpoints.down("sm"), {
        width: "97px",
        height: "97px"
    });
});
var TypographyAvatarVariant1 = (0,styled_esm/* default */.Z)(styles/* StyledTypographyAvatar */.Rq)({});
var TypographyAvatarVariant2 = (0,styled_esm/* default */.Z)(styles/* StyledTypographyAvatar */.Rq)({
    fontFamily: "ES Klarheit Kurrent",
    fontWeight: 200,
    color: "#1A3586"
});

;// CONCATENATED MODULE: ./components/profiles/Intro/components/Avatar/index.tsx
function Avatar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var Variants;
(function(Variants) {
    Variants["VARIANT1"] = "variant1";
    Variants["VARIANT2"] = "variant2";
})(Variants || (Variants = {}));
var useAvatarConfig = function() {
    var variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Variants.VARIANT1;
    var variant1 = {
        Avatar: AvatarVariant1,
        AvatarContainer: AvatarContainerVariant1,
        TypographyAvatar: TypographyAvatarVariant1,
        PlayVideoButton: styles/* StyledPlayVideoButton */.O0
    };
    switch(variant){
        case Variants.VARIANT1:
            {
                return variant1;
            }
        case Variants.VARIANT2:
            {
                return {
                    Avatar: AvatarVariant2,
                    AvatarContainer: AvatarContainerVariant2,
                    TypographyAvatar: TypographyAvatarVariant2,
                    PlayVideoButton: (0,styled_esm/* default */.Z)(styles/* StyledPlayVideoButton */.O0)(function(param) {
                        var theme = param.theme;
                        return Avatar_defineProperty({}, theme.breakpoints.down("sm"), {
                            "&>svg": {
                                margin: "-12px"
                            }
                        });
                    })
                };
            }
        default:
            {
                return variant1;
            }
    }
};
var Avatar = function(param) {
    var variant = param.variant, isEntryOrUnclaimed = param.isEntryOrUnclaimed, handleOpenVideoPlayer = param.handleOpenVideoPlayer, title = param.title, id = param.id, image = param.image, name = param.name, introVideoAvailable = param.introVideoAvailable;
    var ref, ref1;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var imageWithWWW = (0,getImageWithWWW/* default */.Z)(image);
    var initials = (0,variants_default/* getInitialsFromFullName */.u)(name);
    var ref2 = useAvatarConfig(variant), Avatar1 = ref2.Avatar, AvatarContainer = ref2.AvatarContainer, TypographyAvatar = ref2.TypographyAvatar, PlayVideoButton = ref2.PlayVideoButton;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
            item: true,
            maxHeight: "min-content",
            position: "relative",
            mr: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                    onClick: handleOpenVideoPlayer,
                    variant: "ghost",
                    sx: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar1, {
                        width: 104,
                        height: 104,
                        alt: title || "",
                        src: !isEntryOrUnclaimed ? imageWithWWW : "",
                        preload: true,
                        sx: {
                            backgroundColor: !isEntryOrUnclaimed && image ? "transparent" : "blue.200"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyAvatar, {
                            children: initials
                        })
                    })
                }),
                introVideoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayVideoButton, {
                    "aria-label": translate("media_center.introduction_video"),
                    variant: "ghost",
                    onClick: handleOpenVideoPlayer,
                    id: id,
                    "data-testid": constants/* TEST_IDS.PROFILE_INTRO_VIDEO_BUTTON */.z7.PROFILE_INTRO_VIDEO_BUTTON,
                    sx: (ref3 = theme === null || theme === void 0 ? void 0 : (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SearchProfileCard) === null || ref1 === void 0 ? void 0 : ref1.profileAvatarContainer) !== null && ref3 !== void 0 ? ref3 : {},
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* PlayCircleIcon */.z, {
                        sx: {
                            width: "35px",
                            height: "35px"
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Avatar = (Avatar);


/***/ }),

/***/ 21684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ IntroTextInformation; },
/* harmony export */   "O0": function() { return /* binding */ StyledPlayVideoButton; },
/* harmony export */   "Rq": function() { return /* binding */ StyledTypographyAvatar; },
/* harmony export */   "WV": function() { return /* binding */ StyledPlayVideoButtonMobile; },
/* harmony export */   "Zq": function() { return /* binding */ TopKeywordText; },
/* harmony export */   "bw": function() { return /* binding */ StyledAvatar; },
/* harmony export */   "oh": function() { return /* binding */ ProfileDetailsContainer; },
/* harmony export */   "yJ": function() { return /* binding */ StyledAvatarContainer; },
/* harmony export */   "zC": function() { return /* binding */ TextBox; }
/* harmony export */ });
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84857);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93247);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75320);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26546);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54597);
/* harmony import */ var _Avatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var StyledPlayVideoButton = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return _objectSpread({}, theme.custom.SearchProfileCard.buttonForIntro.desktop, _defineProperty({
        position: "absolute",
        padding: 0,
        zIndex: 2,
        minWidth: "auto"
    }, theme.breakpoints.down("lg"), _objectSpread({}, theme.custom.SearchProfileCard.buttonForIntro.mobile)));
});
var StyledPlayVideoButtonMobile = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    position: "absolute",
    bottom: "-10px",
    left: "40px",
    transform: "translateX(-50%)",
    padding: 0,
    zIndex: 2,
    minWidth: "auto"
});
var StyledTypographyAvatar = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        fontSize: 96,
        color: "#11245A"
    }, theme.breakpoints.down("sm"), {
        fontSize: 48
    });
});
var TextBox = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        width: "max-content",
        backgroundColor: theme.palette.common.white,
        borderRadius: 16,
        display: "flex",
        justifyContent: "space-around"
    };
});
var TopKeywordText = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return theme.custom.ProfileIntro.profileKeywordTypography;
});
var IntroTextInformation = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return _objectSpread({}, theme.typography.body2, {
        lineHeight: "20px"
    });
});
var StyledAvatarContainer = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        width: "192px",
        height: "192px"
    }, theme.breakpoints.down("sm"), {
        width: "104px"
    });
});
var StyledAvatar = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Avatar__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        width: "192px",
        height: "192px"
    }, theme.breakpoints.down("sm"), {
        width: "104px",
        height: "104px"
    });
});
var ProfileDetailsContainer = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2, ref3;
    return _defineProperty({
        gap: (ref = theme.custom.SpecialistPage) === null || ref === void 0 ? void 0 : (ref1 = ref.intro) === null || ref1 === void 0 ? void 0 : ref1.gap,
        marginTop: (ref2 = theme.custom.SpecialistPage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.intro) === null || ref3 === void 0 ? void 0 : ref3.mt
    }, theme.breakpoints.down("sm"), {
        gap: "8px",
        marginTop: 0
    });
});


/***/ }),

/***/ 6875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ variants_default; },
  "u": function() { return /* binding */ getInitialsFromFullName; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/MedicalServices/index.esm.js


const MedicalServicesIcon = (props) => (react.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    react.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "#112971" }),
    react.createElement("path", { d: "M16.8741 8.73701H15.5351V7.31589C15.5351 6.29995 14.7335 5.47382 13.7148 5.47382H10.2855C9.26626 5.47382 8.46488 6.29995 8.46488 7.31589V8.73701H7.12561C6.213 8.73701 5.47362 9.44159 5.47362 10.3515V16.6078C5.47362 17.5174 6.213 18.2547 7.12561 18.2547H16.8741C17.7865 18.2547 18.5264 17.5174 18.5264 16.6076V10.3515C18.5264 9.44159 17.7865 8.73701 16.8741 8.73701ZM9.55261 7.31589C9.55261 6.93546 9.90394 6.56155 10.2855 6.56155H13.7148C14.0952 6.56155 14.4474 6.93546 14.4474 7.31589V8.73701H9.55261V7.31589ZM14.9913 14.7195H13.0877V16.6231H10.9123V14.7195H9.00874V12.5441H10.9123V10.6405H13.0877V12.5441H14.9913V14.7195Z", fill: "white" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(43427);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/utils/formatters.esm.js
var formatters_esm = __webpack_require__(82708);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/Unverified/index.esm.js
var Unverified_index_esm = __webpack_require__(89165);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ShiledMan/index.esm.js
var ShiledMan_index_esm = __webpack_require__(56200);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/CheckCircleOutline.esm.js
var CheckCircleOutline_esm = __webpack_require__(21270);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ConnectionsBadge/index.esm.js
var ConnectionsBadge_index_esm = __webpack_require__(59733);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 3 modules
var Button_esm = __webpack_require__(93247);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/Edit/index.esm.js
var Edit_index_esm = __webpack_require__(9430);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/LocationOn/index.esm.js
var LocationOn_index_esm = __webpack_require__(67227);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(55848);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(63040);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(57419);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(12814);
// EXTERNAL MODULE: ./utils/cookie.ts
var cookie = __webpack_require__(80154);
// EXTERNAL MODULE: ./utils/address.ts
var utils_address = __webpack_require__(46699);
// EXTERNAL MODULE: ./constants/profile.ts
var profile = __webpack_require__(77225);
// EXTERNAL MODULE: ./utils/getLanguageFromLocale.ts
var getLanguageFromLocale = __webpack_require__(84656);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(21684);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var profiles_styles = __webpack_require__(15777);
// EXTERNAL MODULE: ./components/Icons/FeeAgreedBadge.tsx
var FeeAgreedBadge = __webpack_require__(47010);
// EXTERNAL MODULE: ./components/Icons/FeeAgreedBadgeReversed.tsx
var FeeAgreedBadgeReversed = __webpack_require__(25056);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(55677);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(58877);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(76467);
// EXTERNAL MODULE: ./components/profiles/Intro/components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(95916);
;// CONCATENATED MODULE: ./components/profiles/Intro/variants/default/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// todo: refactor this file!



















var claimYourProfile = "claim-your-profile";
var Badge = function(param) {
    var icon = param.icon, title = param.title, color = param.color, testId = param.testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextBox */.zC, {
        color: color || "common.white",
        height: "32px",
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                variant: "subtitle2",
                color: color || "system.navy",
                textTransform: "uppercase",
                lineHeight: "initial",
                ml: 1,
                mr: 2,
                my: 0.5,
                fontWeight: 500,
                display: "flex",
                component: "p",
                alignItems: "center",
                "data-testid": testId,
                children: title
            })
        ]
    });
};
var FeeAgreedTooltip = function(param) {
    var children = param.children;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
        title: translate("filter.fee-agreed.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                width: "fit-content"
            },
            children: children
        })
    });
};
var PremiumTooltip = function(param) {
    var children = param.children;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
        title: translate("filter.premium.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                width: "fit-content"
            },
            children: children
        })
    });
};
var getInitialsFromFullName = function(fullName) {
    var splittedName = fullName.split(" ");
    var firstName = splittedName[0];
    var lastName = splittedName[splittedName.length - 1];
    return firstName[0] + lastName[0];
};
// todo: move out if it's grow
var useComponentsConfig = function() {
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    return {
        displayVideoConsultationBadge: !isWPA
    };
};
// todo: fix complexity
// eslint-disable-next-line complexity
function Default(param) {
    var id = param.id, name = param.name, title = param.title, premium = param.premium, feeAgreed = param.feeAgreed, plan = param.plan, slug = param.slug, image = param.image, keywords = param.keywords, yearsOfExperience = param.yearsOfExperience, address = param.address, isClinic = param.isPractice, practices = param.practices, _isUnclaimed = param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _isEntry = param.isEntry, isEntry = _isEntry === void 0 ? false : _isEntry, videoConsultation = param.videoConsultation, _introVideoAvailable = param.introVideoAvailable, introVideoAvailable = _introVideoAvailable === void 0 ? false : _introVideoAvailable, _setVideoPlayerVisibility = param.setVideoPlayerVisibility, setVideoPlayerVisibility = _setVideoPlayerVisibility === void 0 ? function() {
        return null;
    } : _setVideoPlayerVisibility, profileAnalytics = param.profileAnalytics, _connectionsCount = param.connectionsCount, connectionsCount = _connectionsCount === void 0 ? 0 : _connectionsCount;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref7 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref7.language, locale = ref7.locale, isRtl = ref7.isRtl;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var formattedCount = (0,react.useMemo)(function() {
        return isClinic ? (0,formatters_esm/* formatNumberWithPlus */.Y)(connectionsCount) : connectionsCount;
    }, [
        isClinic,
        connectionsCount
    ]);
    var ref8 = (0,profiles_styles/* themedColor */.St)(), textColor = ref8.textColor, iconColor = ref8.iconColor;
    var isEntryOrUnclaimed = (0,react.useMemo)(function() {
        return isEntry || isUnclaimed;
    }, [
        isEntry,
        isUnclaimed
    ]);
    var displayVideoConsultationBadge = useComponentsConfig().displayVideoConsultationBadge;
    var defaultCountry = (0,global/* getDefaultCountry */.qH)(locale);
    var showTrustBadge = (0,react.useMemo)(function() {
        if (isWPA) {
            return false;
        }
        if (isClinic) {
            return connectionsCount >= profile/* CONNECTION_COUNT_TRUST_BADGE_PRACTICE */.D6;
        }
        return connectionsCount >= profile/* CONNECTION_COUNT_TRUST_BADGE_SPECIALIST */.w;
    }, [
        connectionsCount,
        isClinic,
        isWPA
    ]);
    var trustBadgeTooltipText = (0,react.useMemo)(function() {
        return translate("profile.intro.trustedNetwork.tooltip".concat(isClinic ? "-practice" : ""), {
            connectionsCount: String(formattedCount)
        });
    }, [
        formattedCount,
        isClinic,
        translate
    ]);
    var isMarketingEmail = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_source) === "marketingemail";
    var CTAUrl = isMarketingEmail ? "/".concat(locale).concat(router.asPath.split("?")[0], "/").concat(locale === "de" || locale === "de-at" ? "beanspruchen-sie-ihr-profil" : claimYourProfile) : profile/* doctifyProviderDomain */.iJ + profile/* pathMap */.hn[locale] + profile/* endpoint */.FP;
    var topLevelKeywords = (0,useKeywordsMapper/* useTopLevelKeywords */.F)(keywords || []);
    var ref9 = (0,useKeywordsMapper/* useKeywordsMapper */._)(keywords || [], isClinic), specialties = ref9.specialties, subSpecialties = ref9.subSpecialties;
    var lang = (0,getLanguageFromLocale/* default */.Z)(locale);
    var userTitle = (0,react.useMemo)(function() {
        var ut = name;
        if (title) {
            ut = "".concat(title, " ").concat(ut);
        }
        return ut;
    }, [
        name,
        title
    ]);
    var yearsOfExperienceValue = (0,react.useMemo)(function() {
        return (0,date/* getYearsDiff */.qW)(yearsOfExperience || "");
    }, [
        yearsOfExperience
    ]);
    var transformedAddress = (0,react.useMemo)(function() {
        var addressToTransform = address || (0,utils_address/* getAddressFromPractices */.zz)(practices);
        if (!addressToTransform) {
            return "";
        }
        return address ? (0,utils_address/* transformAddressToString */.CU)(addressToTransform, language) : (0,utils_address/* transformAddressToShortString */.c5)(addressToTransform, language);
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        address,
        practices,
        isClinic
    ]);
    var profileVerifiedStatus = (0,react.useMemo)(function() {
        if (isUnclaimed) {
            return translate("unverivied_profile");
        }
        if (isWPA) {
            return isClinic ? translate("verified_practice") : translate("verified_practitioner");
        }
        return translate("verified_profile");
    }, [
        isClinic,
        isUnclaimed,
        isWPA,
        translate
    ]);
    var medicalServicesIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicalServicesIcon, {
        width: "32px",
        height: "32px"
    });
    var handleOpenVideoPlayer = function() {
        if (introVideoAvailable) {
            if (window) {
                window.dataLayer.push(_objectSpread({
                    event: "prf_pg_prf_vid_click",
                    cont_prf_name: userTitle
                }, profileAnalytics));
            }
            setVideoPlayerVisibility(true);
        }
    };
    var verifiedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
            xlinkHref: "#verified-circle-icon"
        })
    });
    var unverifiedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
        borderRadius: 5,
        bgcolor: "system.coral200",
        p: 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Unverified_index_esm/* default */.Z, {
            sx: {
                height: 32,
                width: 32
            },
            color: "inherit",
            fill: "#051851"
        })
    });
    var renderBadges = function() {
        if (isWPA) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                smUp: true,
                implementation: "css",
                children: [
                    !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShiledMan_index_esm/* ShieldManIcon */.z, {
                                sx: {
                                    width: "16px",
                                    path: {
                                        stroke: theme.palette.common.white
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                color: textColor,
                                textTransform: "capitalize",
                                children: translate("years_of_experience", {
                                    years: yearsOfExperienceValue
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline_esm/* default */.Z, {
                                sx: {
                                    width: "16px",
                                    path: {
                                        color: theme.palette.common.white
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                color: textColor,
                                textTransform: "capitalize",
                                children: profileVerifiedStatus
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            display: "flex",
            gap: 2,
            flexDirection: "row",
            wrap: "nowrap",
            children: [
                isUnclaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: unverifiedIcon,
                    title: translate("unverivied_profile")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: verifiedIcon,
                    testId: constants/* TEST_IDS.PROFILE_INTRO_VERIFIED */.z7.PROFILE_INTRO_VERIFIED,
                    title: translate("verified_profile")
                }),
                !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: medicalServicesIcon,
                    title: translate("years_of_experience", {
                        years: yearsOfExperienceValue
                    })
                })
            ]
        });
    };
    var ProfileDetails = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ProfileDetailsContainer */.oh, {
            container: true,
            direction: "column",
            sx: {
                pb: {
                    xs: "8px",
                    sm: 0
                }
            },
            children: [
                renderBadges(),
                showTrustBadge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    gap: "6px",
                    my: "8px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                            isRtl: isRtl,
                            title: trustBadgeTooltipText,
                            componentsProps: {
                                tooltip: {
                                    sx: _objectSpread({}, isMobile ? {
                                        "&:before": {
                                            left: "12% !important"
                                        },
                                        "&:after": {
                                            left: "12% !important"
                                        }
                                    } : {}, {
                                        height: "auto !important",
                                        padding: "15px 10px !important"
                                    })
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectionsBadge_index_esm/* default */.Z, {
                                    withCheck: false,
                                    count: formattedCount,
                                    width: "16px",
                                    height: "16px"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            variant: "body2",
                            color: "text.darkNavy",
                            children: translate("profile.intro.trustedNetwork")
                        })
                    ]
                }),
                isClinic && isUnclaimed && !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                color: "primary.main",
                                variant: "body2",
                                children: translate("are_you_manager", {
                                    name: name,
                                    skipBold: true,
                                    defaultMessage: "Are you ".concat(name, " manager?")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_esm/* default */.Z, {
                            variant: "contained",
                            size: "small",
                            sx: {
                                mt: 1,
                                px: 1,
                                py: 0.5
                            },
                            href: CTAUrl,
                            onClick: function() {
                                return (0,cookie/* handleAddCookieCTA */.D)({
                                    id: id,
                                    slug: slug,
                                    type: plan
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    variant: "caption",
                                    mr: 1,
                                    fontWeight: 500,
                                    children: translate(isMarketingEmail ? claimYourProfile : "manage_your_profile")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit_index_esm/* default */.Z, {
                                    fontSize: "inherit"
                                })
                            ]
                        })
                    ]
                }),
                isUnclaimed && !isClinic && !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                        borderRadius: 1,
                        p: {
                            lg: theme.spacing(0.5, 1)
                        },
                        bgcolor: "common.white",
                        display: "inline-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "body2",
                                display: "inline",
                                mr: 2,
                                lineHeight: 2,
                                children: translate("are_you", {
                                    name: name
                                }, {
                                    bold: {
                                        fontWeight: 600
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                                variant: "contained",
                                sx: {
                                    padding: theme.spacing(0.5, 1.5)
                                },
                                href: CTAUrl,
                                onClick: function() {
                                    return (0,cookie/* handleAddCookieCTA */.D)({
                                        id: id,
                                        slug: slug,
                                        type: plan
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    color: "common.white",
                                    fontWeight: 500,
                                    variant: "caption",
                                    children: translate(isMarketingEmail ? claimYourProfile : "manage_your_profile")
                                })
                            })
                        ]
                    })
                }),
                !isClinic && videoConsultation && displayVideoConsultationBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "32",
                            height: "32",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                xlinkHref: "#video-cam-icon"
                            })
                        }),
                        title: "".concat(translate("video"), " ").concat(translate("consultation"))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                    smDown: true,
                    implementation: "css",
                    children: [
                        isClinic && premium && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTooltip, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                style: {
                                    width: "124px",
                                    height: "35px"
                                },
                                "data-testid": constants/* TEST_IDS.PREMIUM_BADGE */.z7.PREMIUM_BADGE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    xlinkHref: "#premium-badge-lined-icon"
                                })
                            })
                        }),
                        !isClinic && feeAgreed && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadge/* default */.Z, {
                                "data-testid": constants/* TEST_IDS.FEE_AGREED_BADGE */.z7.FEE_AGREED_BADGE,
                                sx: {
                                    width: "100px",
                                    height: "30px"
                                }
                            })
                        })
                    ]
                })
            ]
        });
    };
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                wrap: "nowrap",
                sx: {
                    pb: {
                        xs: "8px",
                        sm: "32px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                handleOpenVideoPlayer: handleOpenVideoPlayer,
                                introVideoAvailable: introVideoAvailable,
                                isEntryOrUnclaimed: isEntryOrUnclaimed,
                                name: name,
                                id: "IntroAvatar",
                                image: image,
                                title: userTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smUp: true,
                                implementation: "css",
                                children: [
                                    isClinic && premium && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            style: _objectSpread({
                                                width: "124px",
                                                height: "35px"
                                            }, theme.custom.SearchProfileCard.mobileBadge),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                                xlinkHref: "#premium-badge-lined-icon"
                                            })
                                        })
                                    }),
                                    !isClinic && feeAgreed && isWPA && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadgeReversed/* default */.Z, {
                                            sx: _objectSpread({
                                                width: "100px",
                                                height: "30px"
                                            }, (ref10 = theme === null || theme === void 0 ? void 0 : (ref1 = theme.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.SearchProfileCard) === null || ref2 === void 0 ? void 0 : ref2.mobileBadge) !== null && ref10 !== void 0 ? ref10 : {})
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadge/* default */.Z, {
                                            sx: _objectSpread({
                                                width: "125px",
                                                height: "35px"
                                            }, (ref11 = theme === null || theme === void 0 ? void 0 : (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SearchProfileCard) === null || ref4 === void 0 ? void 0 : ref4.mobileBadge) !== null && ref11 !== void 0 ? ref11 : {})
                                        })
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "h2",
                                component: "h1",
                                sx: _objectSpread({
                                    color: "titleColor.color"
                                }, theme.custom.ProfileIntro.profileTitleTypography),
                                "data-testid": constants/* TEST_IDS.PROFILE_INTRO_AVATAR */.z7.PROFILE_INTRO_AVATAR,
                                children: userTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smDown: true,
                                children: [
                                    isWPA && !isClinic && !!topLevelKeywords ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                        color: textColor,
                                        children: topLevelKeywords
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        mt: 1,
                                        gap: theme.custom.SpecialistPage.detailsContainer.gap,
                                        sx: _defineProperty({
                                            alignItems: "center"
                                        }, theme.breakpoints.down("sm"), {
                                            alignItems: "start",
                                            flexDirection: "column"
                                        }),
                                        children: [
                                            !isWPA && !isClinic && !!topLevelKeywords ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                color: textColor,
                                                children: topLevelKeywords
                                            }) : null,
                                            isClinic && !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                gap: "12px",
                                                sx: {
                                                    pt: {
                                                        xs: 2
                                                    },
                                                    pl: {
                                                        xs: 2.5
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        variant: "subtitle1",
                                                        fontWeight: 500,
                                                        children: (ref5 = specialties[0]) === null || ref5 === void 0 ? void 0 : ref5.name[lang]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                                        sx: {
                                                            fontSize: "10.53px",
                                                            fontWeight: 500,
                                                            lineHeight: "15.795px",
                                                            color: "text.dark",
                                                            padding: "1px 6px",
                                                            span: {
                                                                padding: 0
                                                            }
                                                        },
                                                        label: "+".concat(subSpecialties.length),
                                                        variant: "blue"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                display: "flex",
                                                alignItems: "center",
                                                sx: _defineProperty({
                                                    wrap: "nowrap"
                                                }, theme.breakpoints.down("sm"), _objectSpread({}, !isClinic ? {
                                                    paddingTop: "0 !important"
                                                } : {})),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                                        smDown: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                            sx: {
                                                                ml: isWPA ? 0 : Number(!isClinic),
                                                                width: 16,
                                                                height: 16,
                                                                marginRight: "4px",
                                                                path: {
                                                                    fill: iconColor
                                                                }
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                                        smUp: true,
                                                        children: isClinic && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                            sx: {
                                                                width: 16,
                                                                height: 16,
                                                                marginRight: "4px",
                                                                path: {
                                                                    fill: iconColor
                                                                }
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                        color: textColor,
                                                        "data-testid": constants/* TEST_IDS.PROFILE_INTRO_LOCATION */.z7.PROFILE_INTRO_LOCATION,
                                                        textTransform: "capitalize",
                                                        children: transformedAddress || defaultCountry
                                                    })
                                                ]
                                            }),
                                            isWPA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                                smDown: true,
                                                children: [
                                                    !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        item: true,
                                                        gap: 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShiledMan_index_esm/* ShieldManIcon */.z, {
                                                                sx: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    fill: "none",
                                                                    path: {
                                                                        stroke: theme.palette.common.white
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                                color: textColor,
                                                                textTransform: "capitalize",
                                                                children: translate("years_of_experience", {
                                                                    years: yearsOfExperienceValue
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        item: true,
                                                        gap: 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline_esm/* default */.Z, {
                                                                sx: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    path: {
                                                                        color: theme.palette.common.white
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                                color: textColor,
                                                                textTransform: "capitalize",
                                                                children: profileVerifiedStatus
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smUp: true,
                                implementation: "css",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        mt: 1,
                                        sx: _defineProperty({
                                            alignItems: "center"
                                        }, theme.breakpoints.down("sm"), {
                                            alignItems: "start",
                                            flexDirection: "column"
                                        }),
                                        children: [
                                            !isClinic && !!topLevelKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                color: textColor,
                                                children: topLevelKeywords
                                            }),
                                            isClinic && !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                gap: "12px",
                                                sx: {
                                                    pt: {
                                                        xs: 2
                                                    },
                                                    pl: {
                                                        xs: 2.5
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        variant: "subtitle1",
                                                        fontWeight: 500,
                                                        children: (ref6 = specialties[0]) === null || ref6 === void 0 ? void 0 : ref6.name[lang]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                                        sx: {
                                                            fontSize: "10.53px",
                                                            fontWeight: 500,
                                                            lineHeight: "15.795px",
                                                            color: "text.dark",
                                                            padding: "1px 6px",
                                                            span: {
                                                                padding: 0
                                                            }
                                                        },
                                                        label: "+".concat(subSpecialties.length),
                                                        variant: "blue"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                flexWrap: "nowrap",
                                                sx: _objectSpread({}, theme.custom.IntroSection, _defineProperty({}, theme.breakpoints.down("sm"), _objectSpread({}, !isClinic ? {
                                                    paddingTop: "0 !important"
                                                } : {}))),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                        sx: _objectSpread({}, theme.custom.LocationOnIcon, {
                                                            width: 16,
                                                            height: 16,
                                                            path: {
                                                                fill: iconColor
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                        color: textColor,
                                                        textTransform: "capitalize",
                                                        children: transformedAddress || defaultCountry
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                implementation: "css",
                smUp: true,
                children: !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
            })
        ]
    });
}
/* harmony default export */ var variants_default = (Default);


/***/ }),

/***/ 15777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dg": function() { return /* binding */ PublicationWrapper; },
/* harmony export */   "IW": function() { return /* binding */ StyledDivider; },
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "St": function() { return /* binding */ themedColor; },
/* harmony export */   "T0": function() { return /* binding */ StyledSpecialtiesWrapper; },
/* harmony export */   "aV": function() { return /* binding */ List; },
/* harmony export */   "f$": function() { return /* binding */ ItemWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "l2": function() { return /* binding */ StyledMenu; },
/* harmony export */   "wi": function() { return /* binding */ DayAvailabilityRoot; },
/* harmony export */   "xD": function() { return /* binding */ StyledSectionHeaderWrapper; }
/* harmony export */ });
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36713);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60697);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84857);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47992);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26546);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26025);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15819);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var textDarkNavy = "text.darkNavy";
// eslint-disable-next-line complexity
var themedColor = function() {
    var ref133, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98, ref99, ref100, ref101, ref102, ref103, ref104, ref105, ref106, ref107;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118, ref119, ref120, ref121, ref122, ref123, ref124, ref125, ref126, ref127, ref128, ref129, ref130, ref131, ref132;
    return {
        textColor: (ref108 = (ref133 = theme.custom) === null || ref133 === void 0 ? void 0 : (ref1 = ref133.SpecialistPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.common) === null || ref2 === void 0 ? void 0 : ref2.color) !== null && ref108 !== void 0 ? ref108 : textDarkNavy,
        buttonBackground: "".concat((ref109 = (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SpecialistPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.common) === null || ref5 === void 0 ? void 0 : ref5.background) !== null && ref109 !== void 0 ? ref109 : "#2B59E0", " !important"),
        iconColor: (ref110 = (ref6 = theme.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.SpecialistPage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.common) === null || ref8 === void 0 ? void 0 : ref8.color) !== null && ref110 !== void 0 ? ref110 : theme.palette.text.darkNavy,
        locationTitleColor: (ref111 = (ref9 = theme.custom) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.SpecialistPage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.common) === null || ref11 === void 0 ? void 0 : ref11.background) !== null && ref111 !== void 0 ? ref111 : "common.white",
        borderRadius: (ref112 = (ref12 = theme.custom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.SpecialistPage) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.location) === null || ref14 === void 0 ? void 0 : ref14.containerBorderRadius) !== null && ref112 !== void 0 ? ref112 : "16px",
        chipsTextColor: (ref15 = theme.custom) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.SpecialistPage) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.common) === null || ref17 === void 0 ? void 0 : ref17.chipsTextColor,
        chipsBorder: (ref113 = (ref18 = theme.custom) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.SpecialistPage) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.common) === null || ref20 === void 0 ? void 0 : ref20.border) !== null && ref113 !== void 0 ? ref113 : "1px #2B59E0 solid",
        chipsBorderSelected: (ref114 = (ref21 = theme.custom) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.SpecialistPage) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.common) === null || ref23 === void 0 ? void 0 : ref23.borderSelected) !== null && ref114 !== void 0 ? ref114 : "1px #2B59E0 solid",
        showMoreChipsBackground: (ref115 = (ref24 = theme.custom) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.SpecialistPage) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.review) === null || ref26 === void 0 ? void 0 : ref26.showMoreChips) !== null && ref115 !== void 0 ? ref115 : "rgba(255, 99, 92, 0.2)",
        showMoreChipsColorOfText: (ref116 = (ref27 = theme.custom) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.SpecialistPage) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.review) === null || ref29 === void 0 ? void 0 : ref29.showMoreChipsColor) !== null && ref116 !== void 0 ? ref116 : "common.dark",
        checkboxColor: (ref117 = (ref30 = theme.custom) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.SpecialistPage) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.common) === null || ref32 === void 0 ? void 0 : ref32.background) !== null && ref117 !== void 0 ? ref117 : "#2B59E0",
        specialistLocationSectionBackground: (ref118 = (ref33 = theme.custom) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.SpecialistPage) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.location) === null || ref35 === void 0 ? void 0 : ref35.background) !== null && ref118 !== void 0 ? ref118 : "rgba(17, 41, 113, 0.8)",
        practiceLocationSectionBackground: (ref119 = (ref36 = theme.custom) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.SpecialistPage) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.location) === null || ref38 === void 0 ? void 0 : ref38.background) !== null && ref119 !== void 0 ? ref119 : "linear-gradient(0deg, #051851, #051851), #2C3341",
        endorsementsBackground: (ref120 = (ref39 = theme.custom) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.SpecialistPage) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.endorsements) === null || ref41 === void 0 ? void 0 : ref41.background) !== null && ref120 !== void 0 ? ref120 : "background.light2",
        endorsementsChipsColor: (ref121 = (ref42 = theme.custom) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.SpecialistPage) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.endorsements) === null || ref44 === void 0 ? void 0 : ref44.chipsColor) !== null && ref121 !== void 0 ? ref121 : "rgba(0, 229, 208, 0.2)",
        endorsementsChipsBackground: (ref45 = theme.custom) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.SpecialistPage) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.endorsements) === null || ref47 === void 0 ? void 0 : ref47.chipsBackground,
        endorsementsChipsBorder: (ref48 = theme.custom) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.SpecialistPage) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.endorsements) === null || ref50 === void 0 ? void 0 : ref50.chipsBorder,
        endorsementsChipsSelectedBackground: (ref51 = theme.custom) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.SpecialistPage) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.endorsements) === null || ref53 === void 0 ? void 0 : ref53.chipsSelectedBackground,
        endorsementsChipsSelectedBorder: (ref54 = theme.custom) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.SpecialistPage) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.endorsements) === null || ref56 === void 0 ? void 0 : ref56.chipsSelectedBorder,
        endorsementsChipsTextColor: (ref57 = theme.custom) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.SpecialistPage) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.endorsements) === null || ref59 === void 0 ? void 0 : ref59.chipsTextColor,
        buttonBorder: (ref122 = (ref60 = theme.custom) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.SpecialistPage) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.common) === null || ref62 === void 0 ? void 0 : ref62.border) !== null && ref122 !== void 0 ? ref122 : "",
        focusButtonStyle: (ref123 = (ref63 = theme.custom) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.SpecialistPage) === null || ref64 === void 0 ? void 0 : ref64.LoadMoreButton) !== null && ref123 !== void 0 ? ref123 : {},
        hoverButtonStyle: (ref124 = (ref65 = theme.custom) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.SpecialistPage) === null || ref66 === void 0 ? void 0 : ref66.LoadMoreButtonHover) !== null && ref124 !== void 0 ? ref124 : {},
        buttonBorderRadius: (ref125 = (ref67 = theme.custom) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.SpecialistPage) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.common) === null || ref69 === void 0 ? void 0 : ref69.buttonBorderRadius) !== null && ref125 !== void 0 ? ref125 : "4px",
        titleTextTransform: (ref126 = (ref70 = theme.custom) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.SpecialistPage) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.common) === null || ref72 === void 0 ? void 0 : ref72.titleTextTransform) !== null && ref126 !== void 0 ? ref126 : "uppercase",
        reviewTitleColor: (ref127 = (ref73 = theme.custom) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.SpecialistPage) === null || ref74 === void 0 ? void 0 : (ref75 = ref74.common) === null || ref75 === void 0 ? void 0 : ref75.titleColor) !== null && ref127 !== void 0 ? ref127 : textDarkNavy,
        linearProgressUnselected: (ref128 = (ref76 = theme.custom) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.SpecialistPage) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.common) === null || ref78 === void 0 ? void 0 : ref78.background) !== null && ref128 !== void 0 ? ref128 : "#00E5D0",
        aboutSectionTitleColor: (ref79 = theme.custom) === null || ref79 === void 0 ? void 0 : (ref80 = ref79.SpecialistPage) === null || ref80 === void 0 ? void 0 : (ref81 = ref80.about) === null || ref81 === void 0 ? void 0 : ref81.titleColor,
        aboutSectionTitleFontWeight: (ref129 = (ref82 = theme.custom) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.SpecialistPage) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.about) === null || ref84 === void 0 ? void 0 : ref84.fontWeight) !== null && ref129 !== void 0 ? ref129 : "600",
        progressIndicatorColor: (ref130 = (ref85 = theme.custom) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.SpecialistPage) === null || ref86 === void 0 ? void 0 : (ref87 = ref86.common) === null || ref87 === void 0 ? void 0 : ref87.progressIndicatorColor) !== null && ref130 !== void 0 ? ref130 : theme.palette.system.navy,
        reviewUnselectedTextColor: (ref131 = (ref88 = theme.custom) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.SpecialistPage) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.common) === null || ref90 === void 0 ? void 0 : ref90.color) !== null && ref131 !== void 0 ? ref131 : "common.white",
        chipBackground: (ref91 = theme.custom) === null || ref91 === void 0 ? void 0 : (ref92 = ref91.SpecialistPage) === null || ref92 === void 0 ? void 0 : (ref93 = ref92.common) === null || ref93 === void 0 ? void 0 : ref93.chipBackground,
        chipBorderColor: (ref94 = theme.custom) === null || ref94 === void 0 ? void 0 : (ref95 = ref94.SpecialistPage) === null || ref95 === void 0 ? void 0 : (ref96 = ref95.common) === null || ref96 === void 0 ? void 0 : ref96.chipBorderColor,
        reviewsChipBorder: (ref97 = theme.custom) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.SpecialistPage) === null || ref98 === void 0 ? void 0 : (ref99 = ref98.review) === null || ref99 === void 0 ? void 0 : ref99.chipsBorder,
        reviewsChipColor: (ref100 = theme.custom) === null || ref100 === void 0 ? void 0 : (ref101 = ref100.SpecialistPage) === null || ref101 === void 0 ? void 0 : (ref102 = ref101.review) === null || ref102 === void 0 ? void 0 : ref102.chipsTextColor,
        reviewsChipSelectedBackground: (ref103 = theme.custom) === null || ref103 === void 0 ? void 0 : (ref104 = ref103.SpecialistPage) === null || ref104 === void 0 ? void 0 : (ref105 = ref104.review) === null || ref105 === void 0 ? void 0 : ref105.chipsSelectedBackground,
        loadMoreButtonFocusStyle: (ref132 = (ref106 = theme.custom) === null || ref106 === void 0 ? void 0 : (ref107 = ref106.SpecialistPage) === null || ref107 === void 0 ? void 0 : ref107.LoadMoreButtonFocus) !== null && ref132 !== void 0 ? ref132 : {}
    };
};
var ref;
var StyledButton = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    shouldForwardProp: function(prop) {
        return prop !== "open";
    }
})(function(param) {
    var theme = param.theme, open = param.open;
    var ref140, ref134, ref135, ref136, ref137, ref138, ref139;
    return _objectSpread({}, theme.typography.body2, {
        background: "none",
        border: "1px solid transparent",
        fontWeight: "500",
        borderRadius: "16px",
        display: "flex",
        paddingLeft: "8px",
        paddingRight: "8px",
        height: "24px",
        alignItems: "center",
        cursor: "pointer",
        color: (ref140 = theme.custom) === null || ref140 === void 0 ? void 0 : ref140.SpecialistPage.review.showMoreTextColor,
        "&:hover": {
            border: "1px ".concat((ref = (ref134 = theme.custom) === null || ref134 === void 0 ? void 0 : (ref135 = ref134.SpecialistPage) === null || ref135 === void 0 ? void 0 : (ref136 = ref135.common) === null || ref136 === void 0 ? void 0 : ref136.background) !== null && ref !== void 0 ? ref : "transparent", " solid"),
            backgroundColor: (ref137 = theme.custom) === null || ref137 === void 0 ? void 0 : (ref138 = ref137.SpecialistPage) === null || ref138 === void 0 ? void 0 : (ref139 = ref138.review) === null || ref139 === void 0 ? void 0 : ref139.showMoreBackgroundHover
        },
        fontSize: "11.85px !important",
        "& svg": {
            transform: "rotate(".concat(open ? "180deg" : "0deg", ")")
        }
    });
});
var StyledMenu = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        "& .MuiMenu-paper ": {
            padding: theme.spacing(2),
            boxShadow: "0px 3px 4px rgba(2, 3, 3, 0.03), 0px 3px 3px rgba(2, 3, 3, 0.02), 0px 1px 8px rgba(2, 3, 3, 0.04)",
            borderRadius: 2,
            border: "1px solid ".concat(theme.palette.grey[600])
        },
        "& .MuiList-root ": {
            padding: theme.spacing(0),
            maxHeight: 300,
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": {
                width: 8,
                borderRadius: 8,
                background: "#D5DEF9"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.custom.scrollbarThumb.backgroundColor,
                borderRadius: 8
            }
        },
        "& .MuiButtonBase-root ": {
            minHeight: "24px"
        },
        "& .MuiMenuItem-root": {
            padding: theme.spacing(0),
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    };
});
var ItemWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "spacing";
    }
})(function(param) {
    var theme = param.theme, spacing = param.spacing;
    return {
        display: "flex",
        alignItems: "center",
        maxWidth: "100%",
        margin: spacing === "small" ? theme.spacing(0.5) : theme.spacing(1, 2, 0, 0),
        "&:last-child": {
            marginRight: 0
        }
    };
});
var DayAvailabilityRoot = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        paddingBottom: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        "&:last-child": {
            paddingBottom: 0
        }
    };
});
var Wrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("lg"), {
        flexDirection: "column-reverse"
    });
});
var List = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul")(function(param) {
    var theme = param.theme;
    return _objectSpread({}, theme.typography.body1, {
        paddingLeft: 0,
        color: theme.palette.text.black900,
        textTransform: "capitalize"
    });
});
var StyledSectionHeaderWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        alignItems: "center",
        gap: "8px",
        width: "auto",
        flexWrap: "nowrap"
    }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
        alignItems: "flex-start"
    }), _defineProperty(_obj, "b", {
        fontWeight: 600
    }), _obj;
});
var StyledSpecialtiesWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        gap: "48px"
    });
});
var PublicationWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme, isFirst = param.isFirst, isLast = param.isLast;
    return {
        padding: "16px 0",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "transparent",
        borderBottomColor: isLast ? "transparent" : theme.palette.grey[600],
        borderTopColor: isFirst ? theme.palette.grey[600] : "transparent",
        marginBottom: "-1px",
        contentVisibility: "auto",
        containIntrinsicHeight: "500px",
        "&:hover": {
            backgroundColor: theme.palette.background.default,
            margin: "0 -8px -1px -8px",
            padding: "16px 8px",
            borderColor: "transparent",
            borderRadius: "8px"
        }
    };
});
var StyledDivider = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    return {
        borderColor: "#D5DEF9",
        marginTop: 48,
        marginBottom: 48
    };
});


/***/ }),

/***/ 79279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withError; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _Error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61036);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function withError(Component) {
    return function(_param) {
        var errorCode = _param.errorCode, errorText = _param.errorText, props = _objectWithoutProperties(_param, [
            "errorCode",
            "errorText"
        ]);
        if (errorCode) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Error__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                statusCode: errorCode,
                errorText: errorText
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, props, {
            errorCode: errorCode
        }));
    };
};


/***/ }),

/***/ 55848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTopLevelKeywords; },
/* harmony export */   "_": function() { return /* binding */ useKeywordsMapper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _providers_AppData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63040);


var useKeywordsMapper = function(keywords, isClinic) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var subKeywords = keywords.filter(function(k) {
            return !k.isTopLevelChild;
        });
        return {
            specialties: (isClinic ? keywords : subKeywords).filter(function(keyword) {
                return keyword.isTopLevelChild || keyword.parentId === 1;
            }).sort(function(a, b) {
                return a.sortOrder - b.sortOrder;
            }),
            subSpecialties: (isClinic ? keywords : subKeywords).filter(function(keyword) {
                return keyword.keywordType === "specialty" && !keyword.isTopLevelChild && keyword.parentId !== 1;
            }),
            conditionAndTreatments: subKeywords.filter(function(keyword) {
                return [
                    "condition",
                    "procedure"
                ].includes(keyword.keywordType);
            })
        };
    }, [
        isClinic,
        keywords
    ]);
};
var useTopLevelKeywords = function(keywords) {
    var language = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_AppData__WEBPACK_IMPORTED_MODULE_1__/* .AppDataContext */ .R).language;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return keywords.filter(function(keyword) {
            return keyword.isTopLevelChild && keyword.keywordType === "specialty";
        }).map(function(keyword) {
            var ref;
            return ((ref = keyword.practitioner) === null || ref === void 0 ? void 0 : ref[language]) || keyword.name[language];
        }).join(", ") || "";
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        keywords
    ]);
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getImageWithWWW = function(href) {
    if (!href) {
        return "";
    }
    if ([
        "development.",
        "staging.",
        "www"
    ].some(function(stage) {
        return href.includes(stage);
    })) {
        return href;
    }
    var splitLink = href.split("//");
    var imageWithWWW = "www.".concat(splitLink[1]);
    splitLink[1] = imageWithWWW;
    return splitLink.join("//");
};
/* harmony default export */ __webpack_exports__["Z"] = (getImageWithWWW);


/***/ }),

/***/ 38776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ux": function() { return /* binding */ doctifyCDNLoader; },
/* harmony export */   "xy": function() { return /* binding */ defaultLoader; },
/* harmony export */   "z6": function() { return /* binding */ preloadImageLoader; }
/* harmony export */ });
var defaultLoader = function(param) {
    var src = param.src, width = param.width;
    return "/_next/image?url=".concat(src, "&w=").concat(width, "&q=75");
};
var preloadImageLoader = function(param) {
    var src = param.src, host = param.host;
    return "\n  ".concat(host, "/_next/image?url=").concat(src, "&w=384&q=75");
};
var doctifyCDNLoader = function(param) {
    var src = param.src, width = param.width;
    return "https://cdn.doctify.com/_next/image?url=".concat(src, "&w=").concat(width, "&q=75");
};


/***/ }),

/***/ 23099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ transformAutocompleteKeyword; },
/* harmony export */   "ae": function() { return /* binding */ transformAutocompleteSpecialist; },
/* harmony export */   "bS": function() { return /* binding */ alternativeTransformAutocompletePractices; },
/* harmony export */   "dP": function() { return /* binding */ transformAutocompletePractices; },
/* harmony export */   "lT": function() { return /* binding */ transformSearchType; }
/* harmony export */ });
/* harmony import */ var _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3842);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var transformAutocompleteSpecialist = function(profile, language) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return {
        name: "".concat(profile === null || profile === void 0 ? void 0 : (ref = profile.firstName) === null || ref === void 0 ? void 0 : ref[language], " ").concat((ref1 = profile.lastName) === null || ref1 === void 0 ? void 0 : ref1[language]).trim() || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref2 = profile.images) === null || ref2 === void 0 ? void 0 : ref2.logo,
        subtitle: (ref4 = profile === null || profile === void 0 ? void 0 : (ref3 = profile.keywords) === null || ref3 === void 0 ? void 0 : ref3.find(function(f) {
            return f.keywordType === "specialty";
        })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.name) === null || ref5 === void 0 ? void 0 : ref5[language]
    };
};
var transformAutocompletePractices = function(profile, language) {
    var ref, ref6;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref6 = profile.images) === null || ref6 === void 0 ? void 0 : ref6.logo,
        subtitle: ""
    };
};
var alternativeTransformAutocompletePractices = function(profile, language) {
    var ref, ref7;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref7 = profile.images) === null || ref7 === void 0 ? void 0 : ref7.cover,
        subtitle: ""
    };
};
var transformAutocompleteKeyword = function(keyword, language) {
    var ref;
    return {
        name: (keyword === null || keyword === void 0 ? void 0 : (ref = keyword.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: keyword === null || keyword === void 0 ? void 0 : keyword.id,
        slug: keyword === null || keyword === void 0 ? void 0 : keyword.slug[0],
        logo: keyword === null || keyword === void 0 ? void 0 : keyword.iconUri,
        subtitle: "",
        type: keyword.type
    };
};
var transformSearchType = function(type) {
    var _obj;
    var obj = (_obj = {}, _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.specialists */ .ai.specialists, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.specialists */ .g7.specialists), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.practices */ .ai.practices, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.practices */ .g7.practices), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.dentist */ .ai.dentist, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.dentist */ .g7.dentist), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.healthAndSocialCare */ .ai.healthAndSocialCare, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.healthAndSocialCare */ .g7.healthAndSocialCare), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.hospital */ .ai.hospital, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.hospital */ .g7.hospital), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.pharmacy */ .ai.pharmacy, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.pharmacy */ .g7.pharmacy), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.careHome */ .ai.careHome, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.careHome */ .g7.careHome), _obj);
    return obj[type] || type;
};


/***/ }),

/***/ 67657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CheckCircleOutline; }
/* harmony export */ });
var CheckCircleOutline = {};




/***/ }),

/***/ 95106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useThemeWithoutDefault; }
/* harmony export */ });
var useThemeWithoutDefault = {};




/***/ }),

/***/ 98855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_Grid_Grid_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54597);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




var StarIconDimensions;
(function (StarIconDimensions) {
    StarIconDimensions["XXS"] = "xxs";
    StarIconDimensions["XS"] = "xs";
    StarIconDimensions["SMALL"] = "small";
    StarIconDimensions["LOWMID"] = "low-medium";
    StarIconDimensions["MEDIUM"] = "medium";
    StarIconDimensions["LARGE"] = "large";
})(StarIconDimensions || (StarIconDimensions = {}));
var StarIconSizeValue;
(function (StarIconSizeValue) {
    StarIconSizeValue[StarIconSizeValue["XXS"] = 10] = "XXS";
    StarIconSizeValue[StarIconSizeValue["XS"] = 12] = "XS";
    StarIconSizeValue[StarIconSizeValue["SMALL"] = 16] = "SMALL";
    StarIconSizeValue[StarIconSizeValue["LOWMID"] = 20] = "LOWMID";
    StarIconSizeValue[StarIconSizeValue["MEDIUM"] = 24] = "MEDIUM";
    StarIconSizeValue[StarIconSizeValue["LARGE"] = 40] = "LARGE";
    StarIconSizeValue[StarIconSizeValue["DEFAULT"] = 32] = "DEFAULT";
})(StarIconSizeValue || (StarIconSizeValue = {}));
const getStarIconSize = (size) => {
    switch (size) {
        case StarIconDimensions.XXS:
            return StarIconSizeValue.XXS;
        case StarIconDimensions.XS:
            return StarIconSizeValue.XS;
        case StarIconDimensions.SMALL:
            return StarIconSizeValue.SMALL;
        case StarIconDimensions.LOWMID:
            return StarIconSizeValue.LOWMID;
        case StarIconDimensions.MEDIUM:
            return StarIconSizeValue.MEDIUM;
        case StarIconDimensions.LARGE:
            return StarIconSizeValue.LARGE;
        default:
            return StarIconSizeValue.DEFAULT;
    }
};
const Rating = ({ max = 5, sx, value = 0, size = 'medium', starIconId = '#rating-star-icon', emptyStarIconId = '#rating-empty-star-icon' }) => {
    const iconSize = getStarIconSize(size);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_Grid_Grid_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { container: true, gap: "4px", alignItems: "center", height: "100%", wrap: "nowrap", width: "auto", m: "0 2px", boxSizing: "border-box", sx: sx }, Array.from({ length: max }).map((_, index) => index >= value ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { fontSize: "inherit", viewBox: "0 0 18 17", key: `star-rating-item-${index}-empty`, sx: {
            width: iconSize,
            height: iconSize
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", { href: emptyStarIconId }))) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { fontSize: "inherit", viewBox: "0 0 24 23", key: `star-rating-item-${index}`, sx: {
            width: iconSize,
            height: iconSize
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", { href: starIconId }))))));
};




/***/ }),

/***/ 63759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WH": function() { return /* binding */ CustomTooltip; },
/* harmony export */   "dp": function() { return /* binding */ WhiteTooltip; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_Tooltip_tooltipClasses_esm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55020);
/* harmony import */ var _node_modules_mui_material_Tooltip_Tooltip_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20085);
/* harmony import */ var _node_modules_mui_material_styles_styled_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84857);







const CustomTooltip = (_a) => {
    var { children } = _a, props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["children"]);
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const show = () => setOpen(true);
    const hide = () => setOpen(false);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_Tooltip_Tooltip_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ onMouseEnter: show, onClick: show, onMouseLeave: hide, open: open }, props), children));
};
const WhiteTooltip = (0,_node_modules_mui_material_styles_styled_esm_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_a) => {
    var { className } = _a, props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["className"]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomTooltip, Object.assign({}, props, { classes: { popper: className } }));
}, {
    shouldForwardProp: (prop) => prop !== 'isRtl' && prop !== 'hideArrow'
})(({ isRtl, placement, hideArrow }) => ({
    [`& .${_node_modules_mui_material_Tooltip_tooltipClasses_esm_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tooltip */ .Z.tooltip}`]: Object.assign({ width: '220px', height: '100px', backgroundColor: '#fff', color: '#2C3341', border: '1px solid #AABDF3', boxShadow: '0px 7px 8px 0px #0203030A', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', borderRadius: '5px', fontSize: '12px', fontWeight: 400, top: 0, padding: '15px 20px', zIndex: 99999, textAlign: 'center' }, (!hideArrow
        ? {
            '&:after, &:before': Object.assign({ zIndex: -1, content: '""', position: 'absolute', pointerEvents: 'none' }, (placement === 'right'
                ? {
                    top: '50%',
                    left: '-10px',
                    transform: 'translateY(-50%)'
                }
                : {
                    top: '-10px',
                    left: '50%',
                    transform: 'translateX(-50%)'
                })),
            '&:after': Object.assign({ backgroundColor: '#fff' }, (placement === 'right'
                ? {
                    height: '33px',
                    width: '20px',
                    marginLeft: '10px'
                }
                : {
                    height: '20px',
                    width: '33px',
                    marginTop: '10px'
                })),
            '&:before': Object.assign({ backgroundColor: '#fff', borderRadius: '3px', border: '1px solid #AABDF3', height: '24px', width: '24px' }, (placement === 'right'
                ? {
                    transform: 'rotate(45deg) translateX(-30%) translateY(-40%)'
                }
                : {
                    left: '50%',
                    top: isRtl ? '-22px' : '1px',
                    transform: 'rotate(45deg) translateX(-70%)'
                }))
        }
        : {}))
}));




/***/ }),

/***/ 93716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




const ArrowRight = (_a) => {
    var { color } = _a, props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["color"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16" }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M8 2L6.9425 3.0575L11.1275 7.25H2V8.75H11.1275L6.9425 12.9425L8 14L14 8L8 2Z", fill: color || '#2B59E0' })));
};




/***/ }),

/***/ 9430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Edit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const Edit = ({ color = 'white', fontSize }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { fontSize: fontSize, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 1H9V2H2V14H14V8H15V15H14H1V14V2V1ZM4 12V9.96306L10.0076 3.95546L12.0445 5.99239L6.03694 12H4ZM11.9631 2L14 4.03694L12.6257 5.41662L10.5888 3.37969L11.9631 2Z", fill: color })));




/***/ }),

/***/ 58568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PlayCircleIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const PlayCircleIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ viewBox: "0 0 35 35", fill: "none", style: Object.assign(Object.assign({}, props.style), { borderRadius: '50%', background: '#406AE3' }), xmlns: "http://www.w3.org/2000/svg" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M24.5 16.634C25.1667 17.0189 25.1667 17.9811 24.5 18.366L14.75 23.9952C14.0833 24.3801 13.25 23.899 13.25 23.1292L13.25 11.8708C13.25 11.101 14.0833 10.6199 14.75 11.0048L24.5 16.634Z", fill: "#EAEEFC" })));




/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ formatNumberWithPlus; }
/* harmony export */ });
const formatNumberWithPlus = (num) => {
    if (!num) {
        return undefined;
    }
    const rounded = Math.floor(num / 50) * 50;
    return `${rounded}+`;
};




/***/ })

}]);